import React, { useContext } from "react";
import toastError  from "../../errors/toastError";
import { Checkbox } from "@mui/material";
import { ForwardMessageContext } from "../../context/ForwarMessage/ForwardMessageContext";

const SelectMessageCheckbox = ({ message, className }) => {
  const {
    showSelectMessageCheckbox,
    setSelectedMessages,
    selectedMessages
  } = useContext(ForwardMessageContext);

  const isChecked = selectedMessages.some((m) => m.id === message.id);

  const handleSelectMessage = (e) => {
    e.stopPropagation();
    const checked = e.target.checked;

    setSelectedMessages((prev) => {
      if (checked) {
        if (prev.some((m) => m.id === message.id)) {
          return prev;
        }
        return [...prev, message];
      }

      return prev.filter((m) => m.id !== message.id);
    });
  };

  if (!showSelectMessageCheckbox) {
    return null;
  }

  return (
    <Checkbox
      color="primary"
      size="small"
      disableRipple
      disableFocusRipple
      disableTouchRipple
      tabIndex={-1}
      checked={isChecked}
      onChange={handleSelectMessage}
      onClick={(e) => e.stopPropagation()}
      className={className}
      inputProps={{ "aria-label": "Select message to forward" }}
    />
  );
};

export default SelectMessageCheckbox;